import { useEffect } from 'react';
import { useDispatch, useSelector } from '@s20/hooks/redux.hooks';
import { useSignalR } from '@s20/hooks/signalr.hooks';
import { getTenantId } from '@s20/selectors/features/common.selectors';
import { setTenantSettings } from '@s20/slices/features/common.slice';

const TENANT_SETTINGS_UPDATED = 'TenantSettingsUpdated';

// Keeps the Redux tenant settings in sync with the server in real time. The
// tenant settings page only persists changes to the DB; without this the new
// settings don't apply to the current session until a hard refresh re-hydrates
// the store. The save endpoint broadcasts the updated (flat) settings to this
// tenant's group, so the editor and every other user of the tenant update live.
export const TenantSettingsSync = () => {
    const dispatch = useDispatch();
    const tenantId = useSelector(getTenantId);

    const hub = useSignalR('tenantSettingsHub');

    useEffect(() => {
        if (!hub || !tenantId) {
            return undefined;
        }

        hub.on(TENANT_SETTINGS_UPDATED, (rawData) => {
            if (!rawData) {
                return;
            }

            try {
                const settings = JSON.parse(rawData);

                dispatch(setTenantSettings(settings));
            } catch (e) {
                console.error('Error in TenantSettingsUpdated handler:', e);
            }
        });

        hub.invoke('JoinGroup', `TenantSettings-${tenantId}`)
            .catch((e) => console.info('Unable to join tenant settings hub', e));

        return () => {
            hub.off(TENANT_SETTINGS_UPDATED);
        };
    }, [hub, tenantId, dispatch]);

    return null;
};
